import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return <ToastContainer />;
};
